var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import { getCostApiConfiguration } from "./serializeConfigData";
const pricingUrl = process.env.REACT_APP_HELLOAR_PRICING;
export const uploadSheet = (data, type) => __awaiter(void 0, void 0, void 0, function* () {
    const url = pricingUrl + `upload/${type}`;
    const userString = localStorage.getItem("user");
    const user = userString ? JSON.parse(userString) : undefined;
    const res = yield axios.post(url, data, {
        headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Token ${user.access_token}`,
        },
    });
    return res;
});
export const getPricing = (config) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    if (config.type === "SHARING" || config.type === "NON SHARING") {
        const serializedData = getCostApiConfiguration(config);
        const res = yield axios.post(pricingUrl + "price/", JSON.stringify(serializedData), {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return res.data.totalPrice;
    }
    else {
        const currentTableArray = [
            config.type
                ? config.type.split(" ").join("")
                : (_a = config.type) === null || _a === void 0 ? void 0 : _a.split(" ").join(""),
            config.Length && config.Depth
                ? `${config.Length}Wx${config.Depth}D`
                : undefined,
            config.type === "Cabin Table" ? "MainTable" : undefined,
            config.Dia ? `${config.Dia}Dia` : undefined,
            config.Legs.split(" ").join(""),
        ];
        const currentTable = currentTableArray
            .filter((option) => option !== undefined)
            .join("_");
        const sideTable = config["Side Table"]
            ? "CabinTable_" +
                ((_b = config["Side Table"]) === null || _b === void 0 ? void 0 : _b.split(" x ").join("Wx")) +
                "D_SideTable" +
                "_" +
                config.Legs.split(" ").join("")
            : undefined;
        const pricingReqBody = sideTable === undefined
            ? [
                {
                    name: currentTable,
                    quantity: 1,
                },
            ]
            : [
                {
                    name: currentTable,
                    quantity: 1,
                },
                {
                    name: sideTable,
                    quantity: 1,
                },
            ];
        const res = yield axios.post(pricingUrl + "new/price/", JSON.stringify(pricingReqBody), {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return res.data
            .map((component) => component.price)
            .reduce((acc, curr) => acc + curr);
    }
});
